import React, { Component } from 'react'
import { observer, Provider } from 'mobx-react'
import { hashHistory, Link } from 'react-router'

import { Modal } from 'hljd'
import store from './store'
import mainStore from './store'
import JiaMengMenu from '../JiaMengMenu'
import NewMenu from '../NewMenu'
import BannerPoster from './BannerPoster'
import { withCookieUserChange } from '@merchant-backend/util'
import { isStoreAccount, panguStoreType } from '@util'
import WithStatistic from '@common/WithStatistic'
import Header from '@components/LocalMerchant/Header' // 顶部header
import Shangshangqian from './Shangshangqian'
import PanguMessage from './PanguMessage'
import { withRouter } from 'react-router'
import {
  SHOP_LOGIN_PATH,
  TOP_BANNER_HEIGHT,
  TOP_HEADER_HEIGHT,
  LEFT_MENU_LEVEL1_WIDTH,
  LEFT_MENU_LEVEL2_WIDTH,
  LEFT_MENU_JIAMENG_WIDTH,
  REALNAME_AUTH_PATH,
  HOME_PATH,
} from '@constant'

@withCookieUserChange({
  onOk: () => {
    window.location.href = SHOP_LOGIN_PATH
  },
})
@withRouter
@observer
class Main extends Component {
  componentDidMount() {
    store.init()
  }

  render() {
    const {
      location: { pathname },
      children,
    } = this.props
    let { posterStore, subMenuOpen } = mainStore
    const { hasBannerPoster } = posterStore
    const { isActiveStore, isGrayCrop } = store
    const isJiaMengStore = isStoreAccount()
    const isShow = pathname !== REALNAME_AUTH_PATH
    const isClose = pathname === HOME_PATH
    // 是否展示盘古入口，灰度企业且非盘古迁移类目，需要隐藏盘古入口
    const isShowPangu = isGrayCrop && !panguStoreType()
    return (
      <Provider globalMainStore={mainStore}>
        <>
          <BannerPoster />
          <Header isShowPangu={isShowPangu} />
          {isShow && <Shangshangqian />}
          {isShowPangu && <PanguMessage isShowPangu={isShowPangu} isActiveStore={isActiveStore} isClose={isClose} />}
          <div
            className="body"
            style={{
              paddingTop: hasBannerPoster ? TOP_BANNER_HEIGHT + TOP_HEADER_HEIGHT : TOP_HEADER_HEIGHT,
              paddingLeft: isJiaMengStore
                ? LEFT_MENU_JIAMENG_WIDTH
                : subMenuOpen
                  ? LEFT_MENU_LEVEL1_WIDTH + LEFT_MENU_LEVEL2_WIDTH
                  : LEFT_MENU_LEVEL1_WIDTH,
              height: '100%',
              minWidth: 1280,
            }}
          >
            {isJiaMengStore ? <JiaMengMenu pathname={pathname} /> : <NewMenu pathname={pathname} />}
            {children}
          </div>
        </>
      </Provider>
    )
  }
}

export default WithStatistic(Main)
